import { z } from '@simplisafe/ewok'

export const foundSimpliSafeThroughSchema = z.object({
  title: z.string().default(''),
  placeholder: z.string().default(''),
  options: z.string().array().default([])
})
